import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';
import { computed } from 'vue';
import { getSimpleChoiceMeta } from '@/utils/getSimpleChoiceMeta/getSimpleChoiceMeta';
import {
  SIMPLE_CHOICE,
  SIMPLE_CHOICE_META,
} from '@/features/ChoicesLists/Simple/types';
import { useInputStore } from '@/features/Sparten';

export const hasEqualUeberschusssystemValue: ConditionalRequestDefinition = {
  if: computed(() =>
    getSimpleChoiceMeta(
      SIMPLE_CHOICE.UEBERSCHUSSSYSTEM,
      SIMPLE_CHOICE_META.EXCLUDE_FROM_REQUEST,
    ).includes(useInputStore().ueberschusssystem),
  ),
  drop: ['ueberschusssystem'],
};

export const temporaryField: ConditionalRequestDefinition = {
  if: computed(() => true),
  drop: ['temporaryInputFields'],
};
